import React, { FC } from 'react'
import cx from 'classnames'
import MonthPicker from 'components/MonthPicker/MonthPicker'
import { PeriodProps } from './utils'
import styles from './DatePicker.scss'

interface DatePickerProps {
  periodStart: string
  periodEnd: string
  format?: string
  handlePeriodChange: (period: PeriodProps) => void
  popperPlacement?: string
  isCharts?: boolean
  iconUrl?: string
  containerClassName?: string
  iconClassName?: string
  showYearPicker?: boolean
  minMaxValues?: {
    start: {
      min: Date | null
      max: Date | null
    }
    end: {
      min: Date | null
      max: Date | null
    }
  }
}

const DatePicker: FC<DatePickerProps> = ({
  periodStart,
  periodEnd,
  handlePeriodChange,
  format = 'MMMM yyyy',
  popperPlacement,
  isCharts,
  iconUrl,
  containerClassName,
  iconClassName,
  showYearPicker,
  minMaxValues = {},
}) => (
  <MonthPicker
    start={periodStart}
    end={periodEnd}
    isNFT
    format={format}
    onChange={handlePeriodChange}
    popperPlacement={popperPlacement}
    isCharts={isCharts}
    iconUrl={iconUrl}
    containerClassName={cx(styles.container, containerClassName)}
    iconClassName={cx(styles.icon, iconClassName)}
    showYearPicker={showYearPicker}
    minMaxValues={minMaxValues}
  />
)

export default DatePicker
